import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { stylePropType, childrenPropType, STANDARD_TEXT, TSS_BLACK } from 'tss-core-lib-common';

import { DataShape } from './TableCommon';

var styles = void 0;

var getTitle = function getTitle(children, data) {
  if (typeof children === 'string' || children === 'number') {
    return children;
  }

  if (typeof data === 'string' || data === 'number') {
    return data;
  }

  return '';
};
var onClick = function onClick(event) {
  event.preventDefault();
};

var Cell = function Cell(_ref) {
  var id = _ref.id,
      style = _ref.style,
      cellStyle = _ref.cellStyle,
      centered = _ref.centered,
      children = _ref.children,
      data = _ref.data,
      disableClick = _ref.disableClick;

  var content = children;
  if (!content) {
    content = typeof data === 'function' ? data(id) : data;
  }
  return React.createElement(
    'div',
    {
      className: css(STANDARD_TEXT, styles.cell, disableClick && styles.cellClickDisabled, styles.column, centered && styles.centeredCell, style, cellStyle),
      title: getTitle(children, data),
      onClick: disableClick && onClick
    },
    content || ''
  );
};

Cell.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  style: stylePropType,
  cellStyle: stylePropType,
  centered: PropTypes.bool,
  data: DataShape,
  children: childrenPropType,
  disableClick: PropTypes.bool
};

Cell.defaultProps = {
  style: null,
  cellStyle: null,
  data: null,
  centered: false,
  children: null,
  disableClick: null
};
styles = StyleSheet.create({
  column: {
    flex: '1 1 1%',

    ':first-child': {
      paddingLeft: '2.4rem'
    }
  },

  cell: {
    padding: '1.5rem 2rem 1.5rem 1.2rem',
    color: TSS_BLACK(),
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
  },
  cellClickDisabled: {
    cursor: 'default'
  },
  centeredCell: {
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center'
  }
});

export default Cell;